import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { Ibeneficioarios, ICompromisoSocial, IManejosAmbiental, IProgramaMonitoreo } from 'src/app/interface/interfaces';
import { SenaceService } from 'src/app/services/senace.service';

@Component({
  selector: 'app-manejo-ambiental',
  templateUrl: './manejo-ambiental.component.html',
  styleUrls: ['./manejo-ambiental.component.css']
})
export class ManejoAmbientalComponent implements OnInit {
  manejosAmbientales: IManejosAmbiental[] = [];
  compromisoSociales: ICompromisoSocial[] = [];
  programaMonitoreo: IProgramaMonitoreo[] = [];
  beneficiarios: Ibeneficioarios[] = [];

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) { }

  ngOnInit() {
    this.localStorage.getItem('detalle').subscribe(
      resp => {
        let datos = this.senaceService.getManejoAmbiental(resp);
        this.getManejosAmbientales(datos);

        datos = this.senaceService.getBeneficiarios(resp);
        this.getBenediciariosAmbientales(datos);

        datos = this.senaceService.getCompromisoSocial(resp);
        this.getCompromisoSocial(datos);

        datos = this.senaceService.getProgramaMonitoreo(resp);
        this.getProgramaMonitoreo(datos);
      }
    );
  }

  getManejosAmbientales(resultado) {
    let data: any[] = resultado;
    if (data) {
      data.forEach(item => {
        this.manejosAmbientales.push(item);
      });
    }
  }

  getBenediciariosAmbientales(resultado){
    let data: any[] = resultado['beneficiarios'];
    if (data) {
      data.forEach(item => {        
          this.beneficiarios.push(item);        
      });
    }
  }

  getCompromisoSocial(resultado) {
    let data: any[] = resultado;
    if (data) {
      data.forEach(item => {
        if (item.compromisosSociales) {
          this.compromisoSociales.push(item);
        }
      });
    }
  }

  getProgramaMonitoreo(resultado) {
    let data: any[] = resultado;
    if (data) {
      data.forEach(item => {
        if (item.identificacionPunto) {
          item.identificacionPunto.forEach((item2, index2) => {
            let ubicacion = { este: '', norte: '', zona: '', altitud: '' };
            if (item.ubicacion[index2]) {
              ubicacion.este = item.ubicacion[index2].este;
              ubicacion.norte = item.ubicacion[index2].norte;
              ubicacion.zona = item.ubicacion[index2].zona;
              ubicacion.altitud = item.ubicacion[index2].altitud;
            }

            this.programaMonitoreo.push({
              nombre: item2.nombre,
              resolucion: item2.resolucion,
              clase: item2.clase,
              zonaMuestreo: item2.zonaMuestreo,
              tipoProcedencia: item2.tipoProcedencia,
              ubicacion: item2.ubicacion,
              descripcion: item2.descripcion,
              este: ubicacion.este,
              norte: ubicacion.norte,
              zona: ubicacion.zona,
              altitud: ubicacion.altitud
            })
          });
        }
      });
    }
  }

}
